import React, {FC, PropsWithChildren, useRef} from 'react';

import {useVariableHeightElement} from '../../../../common/scroll/useVariableHeightElement';
import {StyledBasicGroupDiv} from './basicViewerBase';

/*
 * Component.
 */

export const BasicViewerGroup: FC<PropsWithChildren<unknown>> = (props) => {
  const elementRef = useRef<HTMLDivElement>(null);
  useVariableHeightElement(elementRef);

  return <StyledBasicGroupDiv ref={elementRef}>{props.children}</StyledBasicGroupDiv>;
};
